import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withApollo} from 'react-apollo'
import queryString from 'query-string'
import {GET_ELEMENTS, GET_ELEMENT} from './graphql'
import {destroyProjectsMutation} from '../mutations'
import {RiseLoader} from 'react-spinners'
import {Button} from 'reactstrap'
import ElementModal from '../helpers/ElementModal'
import ConfirmModal from '../../Alerts/ConfirmModal'
import {getUserPermissions} from '../../../utils/userPermissions'
import ElementsList from '../helpers/ElementsList'

const propTypes = {
  parentId: PropTypes.number.isRequired,
  parentElement: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  companiesData: PropTypes.array.isRequired
}

class ElementsTab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formIsOpened: false,
      dataToEdit: {},
      elementIdRemove: null,
      elements: [],
      page: 1,
      totalPages: 1,
      loading: true,
      loadingMore: false,
      nameFilter: queryString.parse(this.props.location.search).name || ''
    }
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    this.fetchPage(1, true)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.parentId !== this.props.parentId) {
      this.setState({elements: [], page: 1, totalPages: 1, nameFilter: ''}, () => this.fetchPage(1, true))
    }
  }

  componentWillUnmount() {}

  handleScroll(e) {
    const el = e.target
    console.log('scroll', {scrollTop: el.scrollTop, clientHeight: el.clientHeight, scrollHeight: el.scrollHeight, loadingMore: this.state.loadingMore, loading: this.state.loading, page: this.state.page, totalPages: this.state.totalPages})
    if (this.state.loadingMore || this.state.loading) return
    if (this.state.page >= this.state.totalPages) return
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
      this.loadNextPage()
    }
  }

  fetchPage(page, reset = false) {
    const loadingKey = reset ? 'loading' : 'loadingMore'
    this.setState({[loadingKey]: true})
    this.props.client.query({
      query: GET_ELEMENTS,
      variables: {parent_id: this.props.parentId, page, size: 20, name: this.state.nameFilter || undefined},
      fetchPolicy: 'network-only'
    }).then(({data}) => {
      this.setState(prev => ({
        elements: reset ? data.elements.list : [...prev.elements, ...data.elements.list],
        totalPages: data.elements.metadata.total_pages,
        page,
        loading: false,
        loadingMore: false
      }))
    })
  }

  loadNextPage() {
    this.fetchPage(this.state.page + 1)
  }

  handleEdit(element) {
    this.props.client.query({
      query: GET_ELEMENT,
      variables: {id: element.id},
      fetchPolicy: 'network-only'
    }).then(({data}) => {
      this.setState({dataToEdit: data.element, formIsOpened: true})
    }).catch(() => {
      this.setState({dataToEdit: element, formIsOpened: true})
    })
  }

  refetch() {
    this.setState({elements: [], page: 1}, () => this.fetchPage(1, true))
  }

  handleNameFilter = (name) => {
    const parsed = queryString.parse(this.props.location.search)
    const newSearch = queryString.stringify({...parsed, name: name || undefined})
    this.props.history.replace(`${this.props.location.pathname}${newSearch ? '?' + newSearch : ''}`)
    this.setState({nameFilter: name, elements: [], page: 1}, () => this.fetchPage(1, true))
  }

  render() {
    const {elements, loading, loadingMore, elementIdRemove} = this.state
    if (loading) {
      return <div style={{textAlign: 'center', padding: '40px'}}><RiseLoader color="#20a8d8" loading={true}/></div>
    }
    return (
      <div style={{padding: '0 20px'}}>
        <ElementModal
          isOpen={this.state.formIsOpened}
          onClose={() => this.setState({formIsOpened: false, dataToEdit: {}})}
          onSaved={() => this.refetch()}
          parentId={this.props.parentId}
          element={this.state.dataToEdit}
          companiesData={this.props.companiesData || []}
        />
        <ConfirmModal
          isOpened={!!elementIdRemove}
          onCancel={() => this.setState({elementIdRemove: null})}
          onConfirm={() => {
            this.props.client.mutate({
              mutation: destroyProjectsMutation,
              variables: {id: elementIdRemove}
            }).then(() => this.setState({elementIdRemove: null}, () => this.refetch()))
          }}
          headerText='Remove Element'
          bodyText='Are you sure you want to delete this element?'
          confirmBtnText='Remove'
        />
        <div style={{position: 'relative', opacity: loadingMore ? 0.5 : 1}}>
            {getUserPermissions('wl_welds.projects.create') && this.props.parentElement.company_permitted &&
            <div style={{marginBottom: 8, overflow: 'hidden'}}>
              <Button
                id="add-new-element"
                color="primary"
                className="float-right"
                onClick={() => this.setState({formIsOpened: true})}>
                <i className="fa fa-plus"/> Add new element
              </Button>
            </div>}
            <ElementsList
              history={this.props.history}
              companiesData={this.props.companiesData}
              onEdit={(element) => this.handleEdit(element)}
              onDestroy={(element_id) => this.setState({elementIdRemove: element_id})}
              elements={elements}
              onScroll={this.handleScroll}
              heightOffset={loadingMore ? 300 : 340}
              onNameFilter={this.handleNameFilter}
              loading={this.state.loading || this.state.loadingMore}
              initialNameFilter={this.state.nameFilter}
            />
            {loadingMore && <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}><RiseLoader color="#20a8d8" loading={true}/></div>}
          </div>
      </div>
    )
  }
}

ElementsTab.propTypes = propTypes

export default withApollo(ElementsTab)



// WEBPACK FOOTER //
// ./src/components/Projects/tabs/ElementsTab.js